import { Component, OnInit } from '@angular/core';
import { ToasterService } from '../../services/toaster.service';
import { NgbAlertConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-toaster',
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss'],
  providers: [NgbAlertConfig]
})
export class ToasterComponent implements OnInit {
  isShowing: boolean;
  message: string;
  type: string;

  constructor(private service: ToasterService, config: NgbAlertConfig) {
    config.dismissible = true;

    this.service.toasterState.subscribe(state => {
      this.isShowing = state.show;
      this.message = state.message;
      this.type = state.type;
    });
  }

  ngOnInit() {}

  onClose() {
    this.service.hideToaster();
  }
}
